import { createFileRoute } from '@tanstack/react-router'

import { Members } from '~/pages/Members'

// Member filter conditions kept in the URL search params, so they survive
// back-navigation from the member detail page and can be shared by URL.
export type MembersSearch = {
  plan?: string[]
  role?: string[]
  status?: number
  keyword?: string
}

// Arrays are serialized as repeated params (plan=a&plan=b), so a single
// occurrence parses back as a plain scalar rather than an array. Numeric-
// looking codes are coerced to numbers by the search parser, so coerce them
// back to strings.
function toStringArray(value: unknown): string[] | undefined {
  const values = Array.isArray(value) ? value : [value]
  const strings = values
    .filter(
      (v): v is string | number =>
        typeof v === 'string' || typeof v === 'number',
    )
    .map(String)
  return strings.length > 0 ? strings : undefined
}

export const Route = createFileRoute('/_authenticated/members/')({
  validateSearch: (search: Record<string, unknown>): MembersSearch => ({
    plan: toStringArray(search.plan),
    role: toStringArray(search.role),
    status: typeof search.status === 'number' ? search.status : undefined,
    keyword:
      typeof search.keyword === 'string' && search.keyword !== ''
        ? search.keyword
        : undefined,
  }),
  component: () => <Members />,
})

export const MembersRoute = Route
